import { render } from "./GPUDevicesTab.vue?vue&type=template&id=ba476fd6&scoped=true"
import script from "./GPUDevicesTab.vue?vue&type=script&lang=js"
export * from "./GPUDevicesTab.vue?vue&type=script&lang=js"

import "./GPUDevicesTab.vue?vue&type=style&index=0&id=ba476fd6&scoped=true&lang=css"

import exportComponent from "/home/baltazor/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba476fd6"]])

export default __exports__